import { Container } from "../NoDataList/NoDataList.styles"

export const NoReviews = () => {
  return (
    <Container className="background">
      <h1>There are no reviews yet!</h1>
      <p>Be the first to leave a review.</p>
    </Container>
  )
}
